import {SNSBridgeTokenOptions, SNSType} from "./typing";


export class BridgeToken {
    type: SNSType;
    appid: string;
    version: string;
    token: string | null;
    snsUserToken: string | null;


    constructor(options: SNSBridgeTokenOptions) {
        const {
            type,
            appid,
            version,
            token,
            snsUserToken
        } = options;
        this.type = type;
        this.appid = appid;
        this.version = version;
        this.token = token;
        this.snsUserToken = snsUserToken;
    }

    static valueOf(data: string) {
        const options = JSON.parse(window.atob(data));
        return new BridgeToken(options);
    }
}